import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogCaptureDiagnosticIntroComponent } from '../dialogs/dialog-capture-diagnostic-intro/dialog-capture-diagnostic-intro.component';
import { DataService } from '../services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-diagnostic-capture',
  templateUrl: './diagnostic-capture.component.html',
  styleUrls: ['./diagnostic-capture.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class DiagnosticCaptureComponent implements OnInit {
  studyLevels: any = [];
  civilStatuses: any = [];
  form: FormGroup;

  constructor(
    public dialog: MatDialog,
    private dataService: DataService,
    private formBuilder: FormBuilder,
    public router: Router
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.maxLength(30)]],
      last_name: ['', [Validators.maxLength(30)]],
      m_last_name: ['', [Validators.maxLength(30)]],
      age: ['', [Validators.required, Validators.min(10), Validators.max(60)]],
      education_level_id: ['', [Validators.required]],
      civil_status_id: ['', [Validators.required]],
      anonymous_survey: [false, [Validators.required]]
    });

    /*setTimeout(() => {
      this.dialog.open(DialogCaptureDiagnosticIntroComponent);
    }, 200);*/

    this.dataService.getCivilStatus().subscribe(response => {
      this.civilStatuses = response;
    });

    this.dataService.getEducationLevels().subscribe(response => {
      this.studyLevels = response;
    });
  }

  anonymousPollChange() {
    if (this.form.value.anonymous_survey) {
      for (const item in this.form.controls) {
        if (this.form.controls[item] && item !== 'anonymous_survey') {
          this.form.controls[item].disable();
          this.form.controls[item].patchValue('');
        }
      }
    } else {
      for (const item in this.form.controls) {
        if (this.form.controls[item]) {
          this.form.controls[item].enable();
        }
      }
    }
  }

  continuePoll() {
    if (this.form.value.anonymous_survey) {
      this.dataService.setDataRegistration(this.form.value);
      this.router.navigate(['/encuesta']);
    } else {
      for (const item in this.form.controls) {
        if (this.form.controls[item] && item !== 'anonymous_survey') {
          this.form.controls[item].markAsTouched();
        }
      }
      if (this.form.valid) {
        this.dataService.setDataRegistration(this.form.value);
        this.router.navigate(['/encuesta']);
      }
    }
  }

  get age() {
    return this.form.get('age');
  }
}
